// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_51-0";